import { render, staticRenderFns } from "./bloodSugar.vue?vue&type=template&id=38583b7a&scoped=true"
import script from "./bloodSugar.vue?vue&type=script&lang=js"
export * from "./bloodSugar.vue?vue&type=script&lang=js"
import style0 from "./bloodSugar.vue?vue&type=style&index=0&id=38583b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38583b7a",
  null
  
)

export default component.exports